import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Collapse, Empty, Skeleton, Typography } from "antd";
import SingleLessonRatingCard from "./SingleLessonRatingCard";

const { Text } = Typography;

const UserLessonRatings = (props: any) => {
  const {
    userRatings,
    userRatingsLoading,
    actions: { getUserRatingsById },
  } = props;
  const { id } = useParams();
  const [userRatingsItems, setUserRatingsItems] = useState([]);

  useEffect(() => {
    getUserRatingsById({ id });
  }, []);

  useEffect(() => {
    if (userRatings?.length > 0) {
      const items = userRatings?.map((userRating: any) => ({
        key: userRating?.id,
        label: (
          <Text className="text-neutral-700 text-base font-bold">
            {userRating?.title}
          </Text>
        ),
        children: (
          <>
            <SingleLessonRatingCard userRating={userRating} />
          </>
        ),
      }));

      setUserRatingsItems(items);
    }
  }, [userRatings]);

  if (userRatingsLoading) {
    return (
      <div className="h-[225px]">
        <Skeleton active />
      </div>
    );
  }

  return (
    <>
      <div className="text-neutral-600 font-semibold text-base mb-4">
        Lesson Ratings
      </div>
      {userRatings && userRatings.length > 0 ? (
        <div className="flex flex-col gap-5 max-h-[340px] overflow-y-auto">
          <Collapse
            bordered={false}
            className="flex flex-col gap-2  border-none bg-white shadow-md rounded-lg"
            items={userRatingsItems}
          />
        </div>
      ) : (
        <div className="flex items-center justify-center h-full pb-[60px]">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      )}
    </>
  );
};

export default UserLessonRatings;
